/**
 * 商品推送
 */
import React, { FC, useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import { classNames } from '@dt/fe-utils'
import { Icon } from 'components'
import CashierController from 'controllers/cashierController'
import { cartMobx, discountMobx } from 'restaurant'
import { decorationMobx, buyTogetherMobx, themeMobx } from '@mobxStore'
import './index.scss'

interface IProps {
  data: any;
}

const ProductRecommendBar: FC<IProps> = ({ data }) => {
  const { recommendBubbleProduct, setRecommendBubbleProduct } = data
  const [bottomStyle, setBottomStyle] = useState(0)
  const isBuyTogether = !!Config.buyTogetherId
  const total = isBuyTogether ? buyTogetherMobx.cartMenuTotal.totalCnt : cartMobx.cartResult.totalCnt

  const handleChangeAdd = (event: React.MouseEvent) => {
    event.stopPropagation()
    closeRecommend()
    CashierController.handleProductToCart({
      type: 'add',
      product: recommendBubbleProduct
    })
  }

  const closeRecommend = () => {
    // 先隐藏，再删除推荐数据
    setRecommendBubbleProduct({
      ...recommendBubbleProduct,
      no: '',
    })
    setTimeout(() => setRecommendBubbleProduct(null), 300)
  }

  useEffect(() => {
    let timer = null
    let bottom = 0
    if (recommendBubbleProduct && recommendBubbleProduct.no) {
      bottom = 134 - (isBuyTogether || !decorationMobx.tabBarVisible ? 73 : 0) - (total > 0 ? 0 : 50)
      if (discountMobx.discountResult?.designatedBuyAgain) {
        bottom += 30
      }
      timer = setTimeout(() => {
        closeRecommend()
      }, 15300)
    }
    setBottomStyle(bottom)
    return () => {
      timer && clearTimeout(timer)
    }
  }, [recommendBubbleProduct, decorationMobx.tabBarVisible, discountMobx.discountResult.designatedBuyAgain, total])

  return (
    decorationMobx.mealDecorates.recommendType === 'bubble' && decorationMobx.mealDecorates.openRecommend === 1 && (
      <div
        className={classNames('product-recommend-bar ', { slideInUp: recommendBubbleProduct && recommendBubbleProduct.no, hasSafe: themeMobx?.data?.tabBar?.enablePosition === 1 })}
        style={{ bottom: `${bottomStyle}px` }}
      >
        <div className='product-recommend-title-wrapper'>
          <Icon name='like' className='icon' />
          <span className='txt'>{i18n.t('menu.recommendBubbleTxt')}</span>
          <Icon name='close' className='close-icon' onClick={() => closeRecommend()} />
        </div>
        {recommendBubbleProduct &&
          <div className='product-recommend-wrapper'>
            <div className='left-info'>
              {!!recommendBubbleProduct.pic && <div className='product-img' style={{ backgroundImage: `url(${recommendBubbleProduct.pic})` }}></div>}
              <div className='product-name'>{recommendBubbleProduct.name}</div>
            </div>
            <div className='right-info'>
              <div className='cart-add-wrap'>
                <Icon name='tianjia' onClick={handleChangeAdd} className='cart-add-icon' />
              </div>
            </div>
          </div>}
      </div>
    )
  )
}

export default observer(ProductRecommendBar)
